import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AddEditYear from "./AddEditYear";
import { yearsWopList, deleteYear } from "../../Redux/Slices/yesrSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FiTrash2 } from "react-icons/fi";
import DeleteModal from "../../Components/DeleteModal";

const Year = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [selectedTableStatus, setSelectedTableStatus] = useState("");
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    const handleOpenDialog = (row) => {
        setSelectedRowData(row);
        setIsDialogOpen(true);
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedRowData(null);
        getYearListFun();
    };

    const handleDeleteClick = (e, id) => {
        e.stopPropagation();
        setIdToDelete(id);
        setIsDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await dispatch(deleteYear({ yearId: idToDelete })).unwrap();
            if (response?.IsSuccess) {
                toast.success(response?.Message || "Year deleted successfully");
                getYearListFun();
            }
        } catch (error) {
            toast.error("Failed to delete year");
        } finally {
            setIsDeleteModalOpen(false);
            setIdToDelete(null);
        }
    };

    const getYearListFun = async () => {
        try {
            setLoading(true);
            const response = await dispatch(yearsWopList({ search: searchValue || "" })).unwrap();
            setTableData(response.Data);
        } catch (error) {
            console.log("error :>> ", error);
        } finally {
            setLoading(false);
        }
    };

    //   const handlePageChange = async (page, limit) => {
    //     setLoading(true);
    //     try {
    //       const response = await dispatch(yearsWopList()).unwrap();
    //       setTableData(response.Data.years);
    //       setLoading(false);
    //     } catch (error) {
    //       console.log("error :>> ", error);
    //     }
    //   };

    const handleAward = (item) => {
        navigate(`/award/${item._id}`, {
            state: { yearData: item }
        });
    };

    useEffect(() => {
        setTimeout(() => {
            getYearListFun();
        }, 500);
    }, [searchValue, selectedTableStatus]);

    return (
        <>
            <div className="p-5 md:p-6 lg:p-7 2xl:p-9 h-full">
                <div className="flex flex-col h-full">
                    {/* Filter Section */}
                    <div className="flex flex-wrap justify-between gap-4 mb-6">
                        <div className="w-full sm:w-auto relative">
                            <input
                                onKeyUpCapture={(e) => setSearchValue(e.target.value)}
                                type="text"
                                placeholder="Search"
                                className="pl-10 pr-4 py-2 border border-gray_1 rounded-md focus:outline-none shadow-custom_shadow"
                            />
                            <span className="absolute left-3 top-3 cursor-pointer">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_1_405)">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.33398 0.167969C3.74413 0.167969 0.833984 3.07812 0.833984 6.66797C0.833984 10.2578 3.74413 13.168 7.33398 13.168C10.9238 13.168 13.834 10.2578 13.834 6.66797C13.834 3.07812 10.9238 0.167969 7.33398 0.167969ZM1.83398 6.66797C1.83398 3.6304 4.29642 1.16797 7.33398 1.16797C10.3716 1.16797 12.834 3.6304 12.834 6.66797C12.834 9.70553 10.3716 12.168 7.33398 12.168C4.29642 12.168 1.83398 9.70553 1.83398 6.66797Z" fill="#AFBACA" />
                                        <path d="M13.0209 11.6478C12.8257 11.4525 12.5091 11.4525 12.3138 11.6478C12.1185 11.8431 12.1185 12.1597 12.3138 12.3549L14.9804 15.0215C15.1757 15.2168 15.4922 15.2168 15.6875 15.0216C15.8828 14.8263 15.8828 14.5097 15.6875 14.3144L13.0209 11.6478Z" fill="#AFBACA" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_405">
                                            <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                        </div>
                        <div className="flex flex-wrap items-center gap-4">
                            <button className="btn flex justify-center items-center space-x-1" onClick={() => handleOpenDialog()}>
                                <span className="flex-shrink-0 group cursor-pointer">
                                    <svg className="group-hover:text-primary transition-colors" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.0003 4.16602V15.8327M4.16699 9.99935H15.8337"
                                            stroke="currentColor"
                                            strokeWidth="1.67"
                                            strokeLinecap="round"
                                            strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <span>Add Years</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex flex-wrap items-center -mx-4">
                    {tableData?.length > 0 ? (
                        tableData.map((item) => (
                            <div key={item?._id} className="w-[calc(100%/1)] sm:w-[calc(100%/2)] lg:w-[calc(100%/3)] xl:w-[calc(100%/4)] p-2.5 lg:p-4"
                                onClick={() => handleAward(item)}>
                                <div className="flex items-center justify-between bg-[#E9EEF5] rounded-3xl p-4 lg:p-6 transition-colors cursor-pointer group">
                                    <span className="text-18 lg:text-20 2xl:text-24 font-bold text-[#1E293B] mx-auto group-hover:text-primary">{item?.year}</span>
                                    <div className="flex items-center space-x-2">
                                        <button className="text-[#1E293B] font-bold" onClick={(e) => { e.stopPropagation(); handleOpenDialog(item); }}>
                                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z" fill="#2D3643" />
                                                <path d="M8.50325 17.6901C7.89325 17.6901 7.33325 17.4701 6.92325 17.0701C6.43325 16.5801 6.22325 15.8701 6.33325 15.1201L6.76325 12.1101C6.84325 11.5301 7.22325 10.7801 7.63325 10.3701L15.5133 2.49006C17.5033 0.500059 19.5233 0.500059 21.5133 2.49006C22.6033 3.58006 23.0933 4.69006 22.9933 5.80006C22.9033 6.70006 22.4233 7.58006 21.5133 8.48006L13.6333 16.3601C13.2233 16.7701 12.4733 17.1501 11.8933 17.2301L8.88325 17.6601C8.75325 17.6901 8.62325 17.6901 8.50325 17.6901ZM16.5733 3.55006L8.69325 11.4301C8.50325 11.6201 8.28325 12.0601 8.24325 12.3201L7.81325 15.3301C7.77325 15.6201 7.83325 15.8601 7.98325 16.0101C8.13325 16.1601 8.37325 16.2201 8.66325 16.1801L11.6733 15.7501C11.9333 15.7101 12.3833 15.4901 12.5633 15.3001L20.4433 7.42006C21.0933 6.77006 21.4333 6.19006 21.4833 5.65006C21.5433 5.00006 21.2033 4.31006 20.4433 3.54006C18.8433 1.94006 17.7433 2.39006 16.5733 3.55006Z" fill="#2D3643" />
                                                <path d="M19.8515 9.83003C19.7815 9.83003 19.7115 9.82003 19.6515 9.80003C17.0215 9.06003 14.9315 6.97003 14.1915 4.34003C14.0815 3.94003 14.3115 3.53003 14.7115 3.41003C15.1115 3.30003 15.5215 3.53003 15.6315 3.93003C16.2315 6.06003 17.9215 7.75003 20.0515 8.35003C20.4515 8.46003 20.6815 8.88003 20.5715 9.28003C20.4815 9.62003 20.1815 9.83003 19.8515 9.83003Z" fill="#2D3643" />
                                            </svg>
                                        </button>
                                        <button className="text-gray-700 hover:text-red transition-color" onClick={(e) => handleDeleteClick(e, item?._id)}>
                                            <FiTrash2 className="w-5 h-5" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="w-full p-6 text-center text-18 xl:text-24 text-gray-500">No data found..!</div>
                    )}
                </div>

            </div>
            {isDialogOpen && (
                <AddEditYear
                    isOpen={isDialogOpen}
                    onClose={handleCloseDialog}
                    // getYearListFun={getYearListFun}
                    rowData={selectedRowData}
                />
            )}
            <DeleteModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={confirmDelete}
            />
        </>
    );
}

export default Year;